export const REPORTS_FOR_STUDENTS = 'reportsForStudents';
export const NO_LESSONS_PER_MONTH = 'noLessonsPerMonth';
export const SCHEDULE_WEEKLY_REMINDER = 'scheduleWeeklyReminder';
export const SIGN_FOR_LESSONS_FROM_WIDGET = 'signForLessonFromWidget';
export const NEGATIVE_STUDENT_BALANCE = 'negativeStudentBalance';
export const TOTAL_EARNED_PER_MONTH = 'totalEarnedPerMonth';
export const ONE_HOUR_BEFORE_LESSON = 'oneHourBeforeLesson';
